<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <div class="headline">iCabbi Firebase Management Console</div>
            <v-card flat>
                <v-card-text color="cyan darken-2" class="white--text">
                    <v-btn color="error" @click="login">{{ $t('login.label') }}</v-btn>
                </v-card-text>
            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
    import { mapGetters } from "vuex";

    export default {
        name: "Login",
        watch: {
            token: function(newValue) {
                if (newValue) {
                    this.$router.replace('/projects');
                }
            }
        },
        computed: {
            ...mapGetters({
                token: "authentication/token",
            }),
        },
        methods: {
            async login() {
                try {
                    const { Zi: { id_token, access_token }, w3: { ig, Paa } } = await this.$gAuth.signIn();
                    const user = { displayName: ig, avatar: Paa };
                    await this.$store.dispatch('authentication/setUser', { user });
                    await this.$store.dispatch('authentication/setToken', { id_token, access_token });
                } catch (error) {
                    console.log(error);
                }
            },
        }
    }
</script>

<style scoped>

</style>
